var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { NumberUtilities } from '../../../../utilities/number-utilities';
import { DataType } from '../../../../models/queries/queries.models';
import * as Enumerable from 'linq';
import { StringUtilities } from "../../../../utilities/strings";
import { DateHelper } from "../../../../utilities/date-helper";
import { DateExpressionParser } from '../../../../configuration/date-expressions';
import "moment";
import moment from "moment";
var QueryFilterUriConverter = /** @class */ (function () {
    function QueryFilterUriConverter(initFilter, filters, page, pageCount, sorting) {
        this.initFilter = initFilter;
        this.page = 0;
        this.pageCount = 100;
        this.filters = filters;
        this.page = page;
        this.pageCount = pageCount;
        this.sorting = sorting;
    }
    QueryFilterUriConverter.filterCollection = function (itemsCollection, columns) {
        var filtersToInclude = [];
        columns.forEach(function (x) {
            if (x.filtersResolver) {
                var filters = x.filtersResolver(x.filters);
                if (filters) {
                    filtersToInclude = filtersToInclude.concat(filters);
                }
            }
            else {
                if (x.filters) {
                    filtersToInclude = filtersToInclude.concat(x.filters);
                }
            }
        });
        itemsCollection = itemsCollection && filtersToInclude && filtersToInclude.length > 0
            ? itemsCollection.filter(function (rowItem) { return QueryFilterUriConverter.areConditionsSatisfied(rowItem, rowItem.item, filtersToInclude); })
            : itemsCollection;
        return itemsCollection;
    };
    QueryFilterUriConverter.areConditionsSatisfied = function (rowItem, item, filters) {
        var groupedFilters = Enumerable.from(filters).groupBy(function (x) { return x.groupColor; });
        var response = true;
        groupedFilters.forEach(function (filterGroup) {
            var groupResponse = true;
            filterGroup.forEach(function (filter) {
                if (filter.isAnd) {
                    groupResponse = groupResponse && QueryFilterUriConverter.propertyComparison(rowItem, item, filter);
                }
                else {
                    groupResponse = groupResponse || QueryFilterUriConverter.propertyComparison(rowItem, item, filter);
                }
            });
            response = response && groupResponse;
        });
        return response;
    };
    QueryFilterUriConverter.unformat = function (value, decimal) {
        // Fails silently (need decent errors):
        value = value || 0;
        // Return the value as-is if it's already a number:
        if (typeof value === "number")
            return value;
        // Default decimal point comes from settings, but could be set to eg. "," in opts:
        decimal = decimal || ".";
        // Build regex to strip out everything except digits, decimal point and minus sign:
        var regex = new RegExp("[^0-9-" + decimal + "]", "g"), unformatted = parseFloat(("" + value)
            .replace(/\((?=\d+)(.*)\)/, "-$1") // replace bracketed values with negatives
            .replace(regex, '') // strip out any cruft
            .replace(decimal, '.') // make sure decimal point is standard
        );
        // This will fail silently which may cause trouble, let's wait and see:
        return !isNaN(unformatted) ? unformatted : 0;
    };
    ;
    QueryFilterUriConverter.propertyComparison = function (rowItem, item, filter) {
        var operation = filter.filterOperator;
        var valueConverter = rowItem.columnKeys[filter.filterProperty.name] && rowItem.columnKeys[filter.filterProperty.name].column
            ? rowItem.columnKeys[filter.filterProperty.name].column.valueConverter
            : null;
        var propertyValue = valueConverter ? rowItem.columnKeys[filter.filterProperty.name].displayValue : item[filter.filterProperty.name];
        var filterValue = filter.filterValue;
        //Here we convert all numbers to double to be able to compare numbers (ex. int cannot be compared to long)
        switch (filter.filterProperty.type) {
            case DataType.Number:
            case DataType.Double:
                propertyValue = propertyValue == null ? null : this.unformat(propertyValue.toString(), null);
                filterValue = this.unformat(filter.filterValue, null);
                break;
            case DataType.Date:
            case DataType.DateTime:
                if (!(propertyValue instanceof Date) && typeof propertyValue == "string") {
                    propertyValue = new Date(propertyValue);
                }
                if (!(filterValue instanceof Date) && typeof filterValue == "string") {
                    filterValue = DateHelper.castDate(filterValue);
                }
                if (filterValue instanceof Date) {
                    filterValue = DateHelper.castDate(filterValue).getTime();
                }
                if (propertyValue instanceof Date) {
                    propertyValue = DateHelper.castDate(propertyValue).getTime();
                }
                break;
            case DataType.Default:
                break;
        }
        if (!filterValue) {
            return true;
        }
        if (propertyValue && typeof propertyValue == "string") {
            propertyValue = propertyValue.toLocaleLowerCase();
        }
        if (typeof filterValue == "string") {
            filterValue = filterValue.toLowerCase();
        }
        switch (operation.translatedSymbol) {
            case "=":
            case "eq":
                return (propertyValue == null && propertyValue == filterValue) || (propertyValue != null && (propertyValue == filterValue));
            case "<>":
            case "ne":
                return (propertyValue == null && propertyValue != filterValue) || (propertyValue != null && (propertyValue != filterValue));
            case "<":
            case "lt":
                return propertyValue != null && (propertyValue < filterValue);
            case "<=":
            case "lte":
                return propertyValue != null && (propertyValue <= filterValue);
            case ">":
            case "gt":
                return propertyValue != null && propertyValue > filterValue;
            case ">=":
            case "gte":
                return propertyValue != null && propertyValue >= filterValue;
            case "endswith({0}, '{1}')":
                return propertyValue == null || StringUtilities.endsWith(propertyValue.toString(), filterValue.toString());
            case "startswith({0}, '{1}')":
                return propertyValue == null || StringUtilities.startsWith(propertyValue.toString(), filterValue.toString());
            case "contains({0}, '{1}')":
                return propertyValue == null || propertyValue.toString().indexOf(filterValue.toString()) > -1;
            default:
                return true;
        }
    };
    QueryFilterUriConverter.prototype.getUri = function (skipPagingAndSorting, includeCount, baseUri, limit) {
        var e_1, _a, e_2, _b, e_3, _c;
        if (includeCount === void 0) { includeCount = true; }
        if (baseUri === void 0) { baseUri = null; }
        if (limit === void 0) { limit = -1; }
        var uri = "";
        //first we should group the filter with their group
        var groupedFilters = Enumerable.from(this.filters).where(function (x) { return x.filterProperty != null; })
            .groupBy(function (filter) { return filter.groupColor; }, function (filter) { return filter; })
            .toArray();
        var outerCounter = 0;
        try {
            for (var groupedFilters_1 = __values(groupedFilters), groupedFilters_1_1 = groupedFilters_1.next(); !groupedFilters_1_1.done; groupedFilters_1_1 = groupedFilters_1.next()) {
                var group = groupedFilters_1_1.value;
                // open bracket for group
                if (outerCounter !== 0) {
                    var item = group.getSource()[0];
                    if (item.skipOnNullOrEmpty && (this.getValue(item) == null || this.getValue(item).toString() == ""))
                        continue;
                    uri += (item.isAnd ? " and" : " or");
                }
                var innerCounter = 0;
                if (group.getSource().length > 0) {
                    uri += "(";
                    try {
                        for (var _d = (e_2 = void 0, __values(group.getSource())), _e = _d.next(); !_e.done; _e = _d.next()) {
                            var item = _e.value;
                            //if this is not the last item in this group we append and / or
                            if (item.skipOnNullOrEmpty && (this.getValue(item) == null || this.getValue(item).toString() == ""))
                                continue;
                            if (innerCounter !== 0) {
                                uri += (item.isAnd ? " and" : " or");
                            }
                            uri += this.getUriPart(item);
                            innerCounter++;
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    //close bracket for group
                    uri += ")";
                }
                innerCounter = 0;
                //if this is not the last item then we need to add an And / Or
                outerCounter++;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (groupedFilters_1_1 && !groupedFilters_1_1.done && (_a = groupedFilters_1.return)) _a.call(groupedFilters_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        //this must be refactored
        if (uri && uri !== "" && uri !== "()") {
            var fullUrl = (baseUri && baseUri.indexOf("?") > 0 ? "&" : "?") + "$filter=";
            fullUrl = (baseUri && baseUri.indexOf("$filter") > 0) ? "" : fullUrl;
            //commented this out because it was doing $filter= and (....) which was breaking
            // if (baseUri && StringUtilities.endsWith(baseUri, ')')) {
            //     fullUrl += " and ";
            // }
            uri = fullUrl + "(" + uri + ")";
        }
        else {
            var fullUrl = (baseUri && baseUri.indexOf("?") > 0 ? "" : "?");
            if (baseUri && StringUtilities.endsWith(baseUri, ')') && uri !== "()" && uri !== "") {
                fullUrl += " and ";
            }
            uri = fullUrl + (uri !== "()" ? uri : "");
        }
        if (!skipPagingAndSorting) {
            //add ordering
            //add paging
            uri += "&$top=" + (this.pageCount != null && this.pageCount !== undefined ? this.pageCount : 100);
            uri += this.page != null ? "&$skip=" + ((this.pageCount ? this.pageCount : 0) * (this.page ? this.page : 0)) : "";
            var sorting = Enumerable.from(this.sorting).where(function (x) { return (x.isAscending != null || x.isGrouping); }).orderBy(function (x) { return x.sortOrder; }).orderBy(function (x) { return x.isGrouping; })
                .distinct(function (x) { return x.name; })
                .toArray();
            if (sorting && sorting.length > 0) {
                uri += "&$orderby=";
                try {
                    for (var sorting_1 = __values(sorting), sorting_1_1 = sorting_1.next(); !sorting_1_1.done; sorting_1_1 = sorting_1.next()) {
                        var order = sorting_1_1.value;
                        uri += order.name + " " + (order.isAscending ? "asc" : "desc") + " ,";
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (sorting_1_1 && !sorting_1_1.done && (_c = sorting_1.return)) _c.call(sorting_1);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                uri = uri.substring(0, uri.length - 1);
            }
            if (includeCount) {
                uri += "&$count=true";
            }
            var grouping = Enumerable.from(this.sorting).where(function (x) { return (x.isGrouping == true); }).orderBy(function (x) { return x.isGrouping; })
                .toArray();
            if (grouping && grouping.length > 0) {
                var index = uri.indexOf("?");
                index = index > -1 ? index : 0;
                var uriSubstring = index > -1 ? uri.substring(index, uri.length) : null;
                uri = "/Genesis.GroupBy(column='";
                uri += grouping[0].name + "',propertyForAggregation=null,aggregationType=null,groupLimit=" + (limit > 0 ? limit : 100) + ")";
                var queryIndex = baseUri.indexOf("?");
                if (queryIndex > -1) {
                    if (baseUri.substring(queryIndex, baseUri.length).length > 1) {
                        var filterStr = baseUri.substring(queryIndex, baseUri.length);
                        uri += filterStr;
                    }
                    baseUri = baseUri.substring(0, queryIndex);
                }
                if (uriSubstring)
                    uri += (uriSubstring.indexOf("?") > -1 || uri.indexOf("?") > -1) ? uriSubstring : "?" + uriSubstring;
                var topIndex = uri.indexOf("&$top");
                var skipIndex = uri.indexOf("&$skip");
                //remove $top if a limit is entered for grouping
                if (topIndex > 0 && limit > 0) {
                    var partToRemove = uri.slice(topIndex, skipIndex);
                    uri = uri.replace(partToRemove, "");
                }
                // uri = uri.substring(0, uri.length - 1);
            }
        }
        if (baseUri && uri && baseUri.indexOf("$filter") != -1 && uri[0] == "(") {
            baseUri += " and ";
        }
        return baseUri ? baseUri.concat(uri) : uri;
    };
    QueryFilterUriConverter.prototype.getUriPart = function (item) {
        var result = "";
        if (item.filterOperator) {
            result += " ";
            if (item.filterOperator.requiresInterpolation && item.filterOperator.requiresInterpolation.toString() == "true") {
                if (item.filterProperty.lookupMappedToProperty && item.filterProperty.type == DataType.Default) {
                    return this.getExpressionForLookupString(item);
                }
                else {
                    result += item.filterOperator.translatedSymbol.replace(/\{0\}/g, this.getPropertyName(item))
                        .replace(/\{1\}/g, this.getFilterValueForUri(item))
                        .replace(/\{2\}/g, this.getFilterValueForUri(item, true));
                }
            }
            else {
                if (item.filterProperty.type == DataType.Date || item.filterProperty.type == DataType.DateTime) {
                    result += this.getDateUriPart(item);
                }
                else {
                    result += this.getPropertyName(item) +
                        " " +
                        item.filterOperator.translatedSymbol +
                        " " +
                        this.getFilterValueForUri(item);
                }
            }
        }
        return result;
    };
    QueryFilterUriConverter.prototype.getPropertyName = function (item) {
        var property = item.filterProperty;
        if (property.isDynamicProperty) {
            if (property.type == DataType.Default) {
                return "jsonValue(jsonData,'$.".concat(item.filterProperty.name, "')");
            }
            else if (property.type == DataType.Date || property.type == DataType.DateTime) {
                return "jsonDate(jsonData,'$.".concat(item.filterProperty.name, "')");
            }
            else if (property.type == DataType.Number) {
                return "jsonInt(jsonData,'$.".concat(item.filterProperty.name, "')");
            }
            else if (property.type == DataType.Double) {
                return "jsonDouble(jsonData,'$.".concat(item.filterProperty.name, "')");
            }
            else if (property.type == DataType.Boolean) {
                return "jsonBool(jsonData,'$.".concat(item.filterProperty.name, "')");
            }
        }
        else {
            return property.name;
        }
    };
    QueryFilterUriConverter.prototype.getExpressionForLookupString = function (item) {
        var eqPart = ("{0} eq '{1}'")
            .replace(/\{0\}/g, item.filterProperty.name)
            .replace(/\{1\}/g, this.getFilterValueForUri(item));
        var startsWithPart = ("startswith({0}, '{1}')")
            .replace(/\{0\}/g, item.filterProperty.name)
            .replace(/\{1\}/g, this.getFilterValueForUri(item) + ',');
        var containsWithPart = ("startswith({0}, '{1}')")
            .replace(/\{0\}/g, item.filterProperty.name)
            .replace(/\{1\}/g, ',' + this.getFilterValueForUri(item) + ',');
        var endsWithPart = ("endswith({0}, '{1}')")
            .replace(/\{0\}/g, item.filterProperty.name)
            .replace(/\{1\}/g, ',' + this.getFilterValueForUri(item));
        switch (item.filterOperator.translatedSymbol) {
            case "startswith({0}, '{1}')": {
                return " (".concat(startsWithPart, " or ").concat(eqPart, ") ");
            }
            case "contains({0}, '{1}')": {
                return " (".concat(endsWithPart, " or ").concat(containsWithPart, " or ").concat(startsWithPart, " or ").concat(eqPart, ") ");
            }
            case "endswith({0}, '{1}')": {
                return " (".concat(endsWithPart, " or ").concat(eqPart, ") ");
            }
            case "{0} eq '{1}'": {
                return " (".concat(eqPart, ") ");
            }
            case "{0} ne '{1}'": {
                var exp = item.filterOperator.translatedSymbol.replace(/\{0\}/g, item.filterProperty.name);
                var part1 = exp.replace(/\{1\}/g, this.getFilterValueForUri(item));
                return " (".concat(part1, ") ");
            }
        }
    };
    QueryFilterUriConverter.prototype.getGroupByUri = function (nameProperty, valueProperty) {
        var uri = "$apply=groupby((" +
            nameProperty +
            "),%20aggregate(" +
            valueProperty +
            "%20with%20sum%20as%20" +
            valueProperty +
            "))";
        return uri;
    };
    QueryFilterUriConverter.prototype.getValue = function (item) {
        var value;
        if (typeof item.filterValue == "function") {
            value = item.filterValue();
        }
        else {
            value = item.filterValue;
        }
        if (item.filterProperty.type == DataType.Default && value) {
            value = value ? value.toString() : value;
            var find = "'";
            var re = new RegExp(find, 'g');
            value = value.replace(re, "''");
        }
        return value;
    };
    QueryFilterUriConverter.prototype.getDateUriPart = function (item, isSecondValue) {
        if (isSecondValue === void 0) { isSecondValue = false; }
        var value;
        value = this.getValue(item);
        var propName = this.getPropertyName(item);
        if (value != null && value !== "") {
            var date = this.parseDate(value, isSecondValue, item.filterProperty.type);
            //returning the date time part if it is date time and the expression is not a day type example today where time needs to be ignored and query is for entire day 
            if (item.filterProperty.type === DataType.DateTime && !DateExpressionParser.isDateExpression(value)) {
                return this.getPropertyName(item) +
                    " " +
                    item.filterOperator.translatedSymbol +
                    " " +
                    date.toJSON();
            }
            var endDateForRangeExpression = DateExpressionParser.getEndDateFromRangeExpression(value, date);
            var now = moment(date).startOf('day');
            var timeOffsetInMinutes = item.filterProperty.type === DataType.DateTime ? -now.utcOffset() : 0;
            var dateStr = void 0;
            var dateToStr = void 0;
            var dateMomentForIneq = now.add(timeOffsetInMinutes, 'minutes');
            var dateForIneqPlusOneDay = dateMomentForIneq.clone().add(1, 'days');
            var dateForIneq = dateMomentForIneq.toDate();
            var dateTo = dateForIneqPlusOneDay.toDate();
            if (DateExpressionParser.isExpressionDateRange(value) && endDateForRangeExpression != null) {
                dateTo = moment(endDateForRangeExpression).add(timeOffsetInMinutes, 'minutes').toDate();
            }
            dateStr = "".concat(dateForIneq.getFullYear(), "-").concat(NumberUtilities.pad2(dateForIneq.getMonth() + 1), "-").concat(NumberUtilities.pad2(dateForIneq.getDate()), "T").concat(NumberUtilities.pad2(dateForIneq.getHours()), ":00:00Z");
            dateToStr = "".concat(dateTo.getFullYear(), "-").concat(NumberUtilities.pad2(dateTo.getMonth() + 1), "-").concat(NumberUtilities.pad2(dateTo.getDate()), "T").concat(NumberUtilities.pad2(dateForIneq.getHours()), ":00:00Z");
            var neDateFilter = "(".concat(propName, " lt ").concat(dateStr, " or ").concat(propName, " ge ").concat(dateToStr, ")");
            var eqDateFilter = "(".concat(propName, " ge ").concat(dateStr, " and ").concat(propName, " lt ").concat(dateToStr, ")");
            var ltDateFilter = "(".concat(propName, " lt ").concat(dateStr, ")");
            var gtDateFilter = "(".concat(propName, " ge ").concat(dateToStr, ")");
            var geDateFilter = "(".concat(propName, " ge ").concat(dateStr, ")");
            var leDateFilter = "(".concat(propName, " lt ").concat(dateToStr, ")");
            if (item.filterProperty.type === DataType.Date || item.filterProperty.type === DataType.DateTime) {
                switch (item.filterOperator.translatedSymbol) {
                    case "eq":
                        return eqDateFilter;
                    case "ne":
                        return neDateFilter;
                    case "lt":
                        return ltDateFilter;
                    case "gt":
                        return gtDateFilter;
                    case "ge":
                        return geDateFilter;
                    case "le":
                        return leDateFilter;
                    default:
                        return dateStr;
                }
            }
        }
        else {
            return "(".concat(propName, " eq null)");
        }
    };
    QueryFilterUriConverter.prototype.parseDate = function (value, isSecondValue, dataType) {
        if (isSecondValue === void 0) { isSecondValue = false; }
        var exp = value ? DateExpressionParser.getDateValue(value.toString(), null) : undefined;
        if (value && typeof value === "string" && exp) {
            var expDate = exp;
            //if data type is date or the expression is a day type example today and yesterday set time 00:00:00
            if (dataType == DataType.Date || DateExpressionParser.isDateExpression(value))
                expDate.setHours(0, 0, 0);
            value = expDate;
        }
        var date = null;
        if (typeof value == "string") {
            date = new Date(value);
        }
        else {
            date = value;
        }
        if (isSecondValue) {
            date.setDate(date.getDate() + 1);
        }
        return date;
    };
    QueryFilterUriConverter.prototype.getFilterValueForUri = function (item, isSecondValue) {
        if (isSecondValue === void 0) { isSecondValue = false; }
        var value;
        value = this.getValue(item);
        //in this case it is a Lookup
        if (item.filterProperty.type === DataType.Lookup ||
            item.filterProperty.type === DataType.HeiricalLookup) {
            if (value == null) {
                return "0";
            }
            return value + "";
        }
        if (typeof value == "string") {
            value = encodeURIComponent(value);
        }
        return value || !this.initFilter
            ? value
            : this.initFilter.fromView(value, item.filterProperty.type);
    };
    return QueryFilterUriConverter;
}());
export { QueryFilterUriConverter };
